import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'comp.AssetLinkDialog.title',
    defaultMessage: 'Get link / Embed',
  },
  tempSectionTitle: {
    id: 'comp.AssetLinkDialog.tempSectionTitle',
    defaultMessage: 'Temporary download link (original file)',
  },
  tempSectionHint: {
    id: 'comp.AssetLinkDialog.tempSectionHint',
    defaultMessage: 'A private, signed link that downloads the original file. Expires in 24 hours.',
  },
  tempSectionTitleConversion: {
    id: 'comp.AssetLinkDialog.tempSectionTitleConversion',
    defaultMessage: 'Temporary download link (this format)',
  },
  tempSectionHintConversion: {
    id: 'comp.AssetLinkDialog.tempSectionHintConversion',
    defaultMessage: 'A private, signed link that downloads this format. Expires in 24 hours.',
  },
  conversionSubtitle: {
    id: 'comp.AssetLinkDialog.conversionSubtitle',
    defaultMessage: 'Links for the {name} format of {asset}.',
  },
  directSectionTitle: {
    id: 'comp.AssetLinkDialog.directSectionTitle',
    defaultMessage: 'Permanent link (full size)',
  },
  directSectionHint: {
    id: 'comp.AssetLinkDialog.directSectionHint',
    defaultMessage: 'Stable CDN link that never expires and serves this format as stored.',
  },
  fullSize: {
    id: 'comp.AssetLinkDialog.fullSize',
    defaultMessage: 'Full size',
  },
  conversionNotPublic: {
    id: 'comp.AssetLinkDialog.conversionNotPublic',
    defaultMessage:
      'This format is private, so it has no permanent link. Make it public with the Public switch in the Formats tab to get CDN links you can embed.',
  },
  copyTempLink: {
    id: 'comp.AssetLinkDialog.copyTempLink',
    defaultMessage: 'Copy temporary download link',
  },
  tempLinkCopied: {
    id: 'comp.AssetLinkDialog.tempLinkCopied',
    defaultMessage: 'Temporary download link copied — expires in 24 hours',
  },
  imageSectionTitle: {
    id: 'comp.AssetLinkDialog.imageSectionTitle',
    defaultMessage: 'Permanent image links (resized)',
  },
  imageSectionHintConversion: {
    id: 'comp.AssetLinkDialog.imageSectionHintConversion',
    defaultMessage:
      'Stable CDN links that resize this format on the fly — ideal for websites and CMSs. Anyone with a link can view the image.',
  },
  imageSectionHint: {
    id: 'comp.AssetLinkDialog.imageSectionHint',
    defaultMessage:
      'Stable CDN links that never expire — ideal for websites and CMSs. Anyone with a link can view the image.',
  },
  sizeSmall: {
    id: 'comp.AssetLinkDialog.sizeSmall',
    defaultMessage: 'Small',
  },
  sizeMedium: {
    id: 'comp.AssetLinkDialog.sizeMedium',
    defaultMessage: 'Medium',
  },
  sizeLarge: {
    id: 'comp.AssetLinkDialog.sizeLarge',
    defaultMessage: 'Large',
  },
  sizeCustom: {
    id: 'comp.AssetLinkDialog.sizeCustom',
    defaultMessage: 'Custom',
  },
  widthLabel: {
    id: 'comp.AssetLinkDialog.widthLabel',
    defaultMessage: 'Width',
  },
  heightLabel: {
    id: 'comp.AssetLinkDialog.heightLabel',
    defaultMessage: 'Height',
  },
  formatLabel: {
    id: 'comp.AssetLinkDialog.formatLabel',
    defaultMessage: 'Format',
  },
  formatAuto: {
    id: 'comp.AssetLinkDialog.formatAuto',
    defaultMessage: 'Auto (best for each browser)',
  },
  copyUrl: {
    id: 'comp.AssetLinkDialog.copyUrl',
    defaultMessage: 'Copy link',
  },
  copyImgSnippet: {
    id: 'comp.AssetLinkDialog.copyImgSnippet',
    defaultMessage: 'Copy <img> code',
  },
  permanentLinkCopied: {
    id: 'comp.AssetLinkDialog.permanentLinkCopied',
    defaultMessage: 'Permanent CDN link copied',
  },
  imgSnippetCopied: {
    id: 'comp.AssetLinkDialog.imgSnippetCopied',
    defaultMessage: 'Image embed code copied',
  },
  videoSectionTitle: {
    id: 'comp.AssetLinkDialog.videoSectionTitle',
    defaultMessage: 'Streams & embeds',
  },
  videoSectionHint: {
    id: 'comp.AssetLinkDialog.videoSectionHint',
    defaultMessage: 'Permanent links for public video formats. Manage visibility in the Formats tab.',
  },
  copyIframeSnippet: {
    id: 'comp.AssetLinkDialog.copyIframeSnippet',
    defaultMessage: 'Copy embed code',
  },
  iframeSnippetCopied: {
    id: 'comp.AssetLinkDialog.iframeSnippetCopied',
    defaultMessage: 'Embed code copied',
  },
  noPublicVideos: {
    id: 'comp.AssetLinkDialog.noPublicVideos',
    defaultMessage:
      'No public video formats yet. Make a format public in the Formats tab to get a permanent link or embed code.',
  },
  copyFailed: {
    id: 'comp.AssetLinkDialog.copyFailed',
    defaultMessage: 'Could not copy the link. Please try again.',
  },
  loading: {
    id: 'comp.AssetLinkDialog.loading',
    defaultMessage: 'Loading…',
  },
});
